<div class="w-full flex-col pt-[26px]">
  <section class="flex px-[29.5px]">
    <div class="grid w-full grid-cols-1 items-end pb-[35px] sm:grid-cols-[auto_auto] sm:items-center sm:pb-[35px]">
      <div class="flex justify-start font-['Roboto'] text-[22px] sm:text-[25px] text-verde sm:text-2xl font-bold">
        {{'components.OtherProductsOfLnHomeComponent.title' | transloco}}
      </div>
      @if(showSeeMore()) {
      <button
        (click)="navigateToAllSpecialProducts()"
        class="mt-[25px] flex justify-end font-['Roboto'] text-base font-medium text-verde sm:mt-[0px] sm:text-lg">
        <span class="hover:underline">{{'buttons.seeAll' | transloco}}</span>
      </button>
      }
    </div>
  </section>
  <!--  Carrusel de productos-->

  <div class="overflow-x-hidden px-[29.5px] pb-[26px] sm:px-[0px] sm:pb-[48px]">
    <ln-products-carousel [products]="products" [showProductsPrice]="true"></ln-products-carousel>
  </div>
</div>
